export default {"src":"/_next/static/media/EarlyPartner.314ff6c3.svg","height":53,"width":48};